// extracted by mini-css-extract-plugin
export default {"ad":"styles_ad__j16KL"};